import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { usePageMeta } from '../utils/pageMeta';

const PrivacyPolicy: React.FC = () => {
    usePageMeta({
        title: 'Privacy Policy | Streven',
        description: 'How Streven collects, uses and protects your Strava data.',
        path: '/privacy-policy',
    });

    return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: '100vw', justifyContent: 'space-between' }}>
        <Header />
        <div style={{ maxWidth: '700px', margin: '40px auto', padding: '20px', background: '#fff', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', textAlign: 'left' }}>
            <h1>Privacy Policy</h1>
            <p><i>Last updated: 14 October 2026</i></p>
            <p>Your privacy is important to us. This Privacy Policy explains what Streven stores, how we use it, and who else sees it.</p>

            <h2>Information We Store</h2>
            <ul>
                <li>Your Strava athlete ID, and the access and refresh tokens Strava gives us so Streven can act for you. The tokens are stored encrypted.</li>
                <li>A copy of your Strava activities (name, type, date, distance, time, pace, heart rate where available, and route outline), so your lists, stats and plans load quickly. We keep it up to date using notifications from Strava.</li>
                <li>Your training plans: your race goal, the plan, the sessions you have ticked off, your chat with the coach, and the preferences you gave it.</li>
                <li>Daily usage counts, so we can apply fair-use limits.</li>
                <li>Activity files created by combine or rounding actions, which are stored only for processing and automatically deleted after 30 days.</li>
                <li>In your browser: your login token and display choices, kept in your browser's local storage. We do not use tracking cookies, advertising or analytics.</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <ul>
                <li>To provide the features you ask for: combining and rounding activities, showing your stats, and building and changing training plans.</li>
                <li>We do not sell your data, use it for advertising, or use it to train AI models.</li>
            </ul>

            <h2>AI Processing</h2>
            <ul>
                <li>To write and revise training plans and your stats summary, Streven sends a summary of your training (such as weekly distance, paces, your longest run and race predictions), your race goal, and the messages you type in the chat to a language model hosted on Amazon Bedrock (AWS).</li>
                <li>Please do not put sensitive personal or health information in the chat.</li>
                <li>Plans and replies are suggestions generated by an AI model. They are not medical or professional coaching advice.</li>
            </ul>

            <h2>Who Else Sees Your Information</h2>
            <ul>
                <li>Strava, when you ask us to upload an activity.</li>
                <li>Amazon Web Services (AWS), which hosts Streven and runs the AI model.</li>
                <li>No one else, except where the law requires it.</li>
            </ul>

            <h2>Keeping and Deleting Your Data</h2>
            <ul>
                <li>We keep your data while you use Streven. You can delete a training plan at any time from the plan list.</li>
                <li>To have everything we hold about you deleted, email <a href="mailto:support@streventools.com" style={{ color: '#007bff', textDecoration: 'underline' }}>support@streventools.com</a> and we will delete it within 30 days.</li>
            </ul>

            <h2>Data Security</h2>
            <ul>
                <li>Streven uses HTTPS, your Strava tokens are encrypted at rest with AWS KMS, and access to stored data is limited.</li>
                <li>No system is perfectly secure, so we cannot guarantee absolute security.</li>
            </ul>

            <h2>Contact</h2>
            <p>Questions about this policy? Email <a href="mailto:support@streventools.com" style={{ color: '#007bff', textDecoration: 'underline' }}>support@streventools.com</a>.</p>
        </div>
        <Footer />
    </div>
    );
};

export default PrivacyPolicy;
